// Interface

import util from '@/utils/classToObject'
import { IMesureTypeState } from './state'
import { AloDbMesureType } from '@/models/alodb/AloDbMesureType'

export class MesureTypeGetter {  
      
  public mesureTypes(state:IMesureTypeState,getters:any) {
    return state.mesureTypes
  }

  public modifiedAdmMesureType(state:IMesureTypeState,getters:any) {
    return state.modifiedAdmMesureType
  }

  public originalAdmMesureType(state:IMesureTypeState,getters:any) {
    return state.originalAdmMesureType
  }

  public mesureTypeLoading(state:IMesureTypeState,getters:any) {
    return state.mesureTypeLoading
  }

  public mesureTypesById(state:IMesureTypeState) {     
    return state.mesureTypes.reduce((acc,value) =>{
        acc[value.MET_ID!] = value
        return acc
    },{}  as {[id:number]:AloDbMesureType})      
  }

  public mesureTypeStatus(state:IMesureTypeState) {     
    return state.status
  }

  public adminMesureTypeFilter(state:IMesureTypeState) {     
    return state.adminFilter
  }
  
}

export default util.classToObject(MesureTypeGetter)